import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Alamance County Portal": {
    parameters: {
      linkUrls: ["https://alamance.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.NC.ALAMANCE_COUNTY,
          name: "Alamance County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "NC",
  },
  "North Carolina ePlan": {
    parameters: {
      linkUrls: ["https://tier2.erplan.net/onlinefiling/filingLogin.htm"],
      staffInputs: {
        fees: true,
        documentTypes: {
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "ePlan",
    state: "NC",
  },
  "Mecklenburg County LEPC": {
    parameters: {
      linkUrls: [
        "https://fulfillmentguide.helpkit.so/chemicals/6NmwbK2GNFS9Az6DhF7Xez/north-carolina/3zaMdYvWX5RaaojQw5HsAD#local-nuances",
      ],
      includeLepcs: [
        {
          id: LEPC_IDS.NC.MECKLENBURG_COUNTY,
          name: "Mecklenburg County",
        },
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "NC",
    dependsOn: ["Tier2SubmitValidation"],
  },
};
